// AUTO-GENERATED by scripts/registry-gen.ts. DO NOT EDIT BY HAND.
// Run `pnpm registry:gen` to refresh from packages/service-*/service.yaml.
// First-install hook re-runs this so the file is always primed.

import type { ServiceManifest } from './schema.js';

export const MANIFESTS: Record<string, ServiceManifest> = {
  "auth": {
    "apiVersion": "vex.vextura.ai/console-section/v1",
    "service": "auth",
    "owner_team": "platform-security",
    "description": "Vex-auth — security perimeter. Manage M2M service accounts, inspect\nactive sessions, and view OIDC discovery metadata.\n",
    "nav": {
      "group": "Identity & Access",
      "label": "Auth",
      "order": 2,
      "icon": "lock"
    },
    "smithy": {
      "source": "vex-auth/smithy/vex_auth.smithy",
      "client": "@vextura/sdk-vex-auth"
    },
    "resources": [
      {
        "name": "ServiceAccount",
        "pattern": "ResourceList",
        "detail": {
          "pattern": "ResourceDetail",
          "tabs": [
            "overview",
            "scopes"
          ]
        },
        "create": {
          "pattern": "CreateWizard",
          "steps": [
            "Identity",
            "Tenant",
            "Scopes",
            "Review"
          ]
        },
        "list": {
          "columns": [
            "clientId",
            "name",
            "tenant",
            "createdAt"
          ],
          "defaultSort": "clientId"
        }
      }
    ],
    "tools": [
      {
        "id": "sessions",
        "pattern": "ResourceList",
        "label": "Sessions"
      },
      {
        "id": "oidc",
        "pattern": "EditorPlayground",
        "label": "OIDC discovery"
      }
    ],
    "exports": [],
    "consumes": [],
    "constraints": [
      {
        "description": "Service-account secrets are returned in cleartext ONCE at creation",
        "rules": [
          "Create response shows a copy-once reveal modal",
          "Secret is never re-read or persisted client-side beyond the modal"
        ]
      }
    ]
  },
  "fn": {
    "apiVersion": "vex.vextura.ai/console-section/v1",
    "service": "fn",
    "owner_team": "platform-core",
    "description": "Function manifests + invocation. Read manifests from vex-config,\ncross-reference with vex-gate's route table to find which HTTP paths\ninvoke each function, fire ad-hoc invocations against any registered\nroute.\n",
    "nav": {
      "group": "Compute",
      "label": "Functions",
      "order": 1,
      "icon": "lock"
    },
    "smithy": {
      "source": "vex-fn/smithy/vex_fn_admin.smithy",
      "client": "@vextura/sdk-vex-fn"
    },
    "resources": [
      {
        "name": "Function",
        "pattern": "ResourceList",
        "detail": {
          "pattern": "ResourceDetail",
          "tabs": [
            "overview",
            "env",
            "routes",
            "invoke"
          ]
        },
        "list": {
          "columns": [
            "name",
            "image",
            "memory",
            "timeout",
            "instances"
          ],
          "defaultSort": "name"
        }
      }
    ],
    "tools": [
      {
        "id": "invoke",
        "pattern": "EditorPlayground",
        "label": "Invoke playground"
      }
    ],
    "exports": [],
    "consumes": [],
    "constraints": [
      {
        "description": "Function manifests are read-only in the console",
        "rules": [
          "Mutations happen via vexctl fn deploy / vex-pipeline",
          "Surface clearly indicates read-only mode"
        ]
      }
    ]
  },
  "gate": {
    "apiVersion": "vex.vextura.ai/console-section/v1",
    "service": "gate",
    "owner_team": "platform-core",
    "description": "Vex-gate — single data-plane entry point. The console surface is\nread-only: route table, health, and async-invocation result polling.\nRoutes themselves are owned by vex-config (push via vexctl, not the UI).\n",
    "nav": {
      "group": "Edge",
      "label": "Gate",
      "order": 1,
      "icon": "lock"
    },
    "smithy": {
      "source": "vex-gate/smithy/vex_gate_admin.smithy",
      "client": "@vextura/sdk-vex-gate"
    },
    "resources": [
      {
        "name": "Route",
        "pattern": "ResourceList",
        "detail": {
          "pattern": "ResourceDetail",
          "tabs": [
            "overview"
          ]
        },
        "list": {
          "columns": [
            "method",
            "path",
            "mode",
            "auth",
            "fnName",
            "targetUrl"
          ],
          "defaultSort": "path"
        }
      }
    ],
    "tools": [
      {
        "id": "health",
        "pattern": "EditorPlayground",
        "label": "Health"
      },
      {
        "id": "invocation",
        "pattern": "EditorPlayground",
        "label": "Async invocation lookup"
      }
    ],
    "exports": [],
    "consumes": [],
    "constraints": [
      {
        "description": "Routes are read-only in the console",
        "rules": [
          "Mutations to the route table happen via vex-config push only",
          "Surface clearly indicates read-only mode"
        ]
      }
    ]
  },
  "iam": {
    "apiVersion": "vex.vextura.ai/console-section/v1",
    "service": "iam",
    "owner_team": "platform-security",
    "description": "Identity & Access Management — users, teams, roles, bindings, resources,\ntrust policies, audit log, authorize sandbox, tenant provisioning.\n",
    "nav": {
      "group": "Identity & Access",
      "label": "IAM",
      "order": 1,
      "icon": "lock"
    },
    "smithy": {
      "source": "vex-iam/smithy/iam.smithy",
      "client": "@vextura/api-clients-iam"
    },
    "resources": [
      {
        "name": "User",
        "pattern": "ResourceList",
        "detail": {
          "pattern": "ResourceDetail",
          "tabs": [
            "overview",
            "audit"
          ]
        },
        "create": {
          "pattern": "CreateWizard",
          "steps": [
            "Identity",
            "HomeTenant",
            "Review"
          ]
        },
        "edit": {
          "pattern": "EditForm"
        },
        "list": {
          "columns": [
            "id",
            "name",
            "email",
            "homeTenant",
            "lastLogin"
          ],
          "defaultSort": "name"
        }
      },
      {
        "name": "Team",
        "pattern": "ResourceList",
        "detail": {
          "pattern": "ResourceDetail",
          "tabs": [
            "overview",
            "members",
            "audit"
          ]
        },
        "create": {
          "pattern": "CreateWizard",
          "steps": [
            "Identity",
            "Parent",
            "Members",
            "Review"
          ]
        },
        "edit": {
          "pattern": "EditForm"
        }
      },
      {
        "name": "Role",
        "pattern": "ResourceList",
        "detail": {
          "pattern": "ResourceDetail",
          "tabs": [
            "overview",
            "statements",
            "audit",
            "test"
          ]
        },
        "create": {
          "pattern": "CreateWizard",
          "steps": [
            "Identity",
            "Trust",
            "Statements",
            "Review"
          ],
          "enforces": [
            "iam-four-rules"
          ]
        },
        "edit": {
          "pattern": "EditForm"
        }
      },
      {
        "name": "Binding",
        "pattern": "ResourceList",
        "detail": {
          "pattern": "ResourceDetail",
          "tabs": [
            "overview",
            "audit"
          ]
        },
        "create": {
          "pattern": "CreateWizard",
          "steps": [
            "Principal",
            "Role",
            "Scope",
            "Review"
          ]
        }
      },
      {
        "name": "Resource",
        "pattern": "ResourceList",
        "detail": {
          "pattern": "ResourceDetail",
          "tabs": [
            "overview",
            "policy",
            "audit"
          ]
        },
        "create": {
          "pattern": "CreateWizard",
          "steps": [
            "VRN",
            "Metadata",
            "Policy",
            "Review"
          ]
        }
      }
    ],
    "tools": [
      {
        "id": "authorize",
        "pattern": "EditorPlayground",
        "label": "Authorize sandbox"
      },
      {
        "id": "tenants-provision",
        "pattern": "CreateWizard",
        "label": "Provision tenant",
        "steps": [
          "Identity",
          "OwnerTeam",
          "InitialAdmin",
          "Review"
        ]
      },
      {
        "id": "audit",
        "pattern": "AuditTable",
        "label": "Audit log"
      }
    ],
    "exports": [
      {
        "id": "IAMRolePicker",
        "purpose": "Searchable select for IAM roles by slug + name"
      },
      {
        "id": "PrincipalPicker",
        "purpose": "Type-segmented (user/team/service) principal picker"
      },
      {
        "id": "TrustPolicyEditor",
        "purpose": "Auto-injects service:admin (IAM Rule 2); blocks removal"
      },
      {
        "id": "PolicyStatementEditor",
        "purpose": "Enforces lowercase allow/deny (Rule 3) and Rule 4 InvokeFunction pairing"
      },
      {
        "id": "OwnerTeamBadge",
        "purpose": "Color-coded team-slug chip from platform-* ownership map"
      },
      {
        "id": "VRNInput",
        "purpose": "Validated VRN input with orphan detection (IAM-specific extension)"
      },
      {
        "id": "AuditLogTable",
        "purpose": "AuditTable pre-wired to IAM GetAuditLog; accepts fixedFilter for embedding"
      },
      {
        "id": "AuthorizeSandbox",
        "purpose": "Embeddable form firing POST /authorize"
      },
      {
        "id": "AssumeRoleButton",
        "purpose": "Button + Modal calling AssumeRole; shows session token with countdown"
      }
    ],
    "consumes": [],
    "constraints": [
      {
        "description": "IAM Four Rules are enforced at form-submit time",
        "rules": [
          "slug always present in PUT body",
          "service:admin always in trust_policy.principals",
          "lowercase \"allow\" / \"deny\" only",
          "every domain action paired with vex-fn:InvokeFunction"
        ]
      }
    ]
  },
  "mcp": {
    "apiVersion": "vex.vextura.ai/console-section/v1",
    "service": "mcp",
    "owner_team": "platform-agent",
    "description": "MCP tool registry + Smithy schema browser. Read-only view of every\n/mcp/* route registered with the gate and every Smithy contract\npushed to vex-config.\n",
    "nav": {
      "group": "Agent",
      "label": "MCP",
      "order": 1,
      "icon": "lock"
    },
    "smithy": {
      "source": "vex-mcp-server/smithy/vex-mcp-server.smithy",
      "client": "@vextura/sdk-vex-mcp"
    },
    "resources": [
      {
        "name": "Tool",
        "pattern": "ResourceList",
        "detail": {
          "pattern": "ResourceDetail",
          "tabs": [
            "overview"
          ]
        }
      },
      {
        "name": "Schema",
        "pattern": "ResourceList",
        "detail": {
          "pattern": "ResourceDetail",
          "tabs": [
            "overview",
            "idl"
          ]
        }
      }
    ],
    "tools": [],
    "exports": [],
    "consumes": [],
    "constraints": [
      {
        "description": "Read-only — MCP route + schema registration happens through vexctl",
        "rules": [
          "Push schemas with `vexctl sdk schema push`",
          "Register routes with `vexctl gate routes deploy`"
        ]
      }
    ]
  },
  "pipeline": {
    "apiVersion": "vex.vextura.ai/console-section/v1",
    "service": "pipeline",
    "owner_team": "platform-orchestration",
    "description": "vex-pipeline — CI/CD runner. Pipelines (repo + branch + YAML), Runs\n(per-trigger jobs with staged execution), Stages (build → integration →\ngate → canary → production), streaming logs, and admin-gated approve /\ncancel actions.\n",
    "nav": {
      "group": "Platform",
      "label": "Pipelines",
      "order": 40,
      "icon": "git-branch"
    },
    "smithy": {
      "source": "vex-pipeline/smithy/vex_pipeline.smithy",
      "client": "@vextura/api-clients-pipeline"
    },
    "resources": [
      {
        "name": "Pipeline",
        "pattern": "ResourceList",
        "detail": {
          "pattern": "ResourceDetail"
        },
        "create": {
          "pattern": "CreateWizard",
          "steps": [
            "Fields",
            "Review"
          ]
        }
      },
      {
        "name": "Run",
        "pattern": "ResourceList",
        "detail": {
          "pattern": "ResourceDetail"
        }
      }
    ],
    "tools": [
      {
        "id": "trigger",
        "pattern": "EditorPlayground",
        "label": "Trigger Pipeline"
      }
    ],
    "exports": [],
    "consumes": [],
    "constraints": []
  },
  "uwf": {
    "apiVersion": "vex.vextura.ai/console-section/v1",
    "service": "uwf",
    "owner_team": "platform-orchestration",
    "description": "Unified-workflow engine — workflow definitions, executions, lifecycle\ncontrols (cancel / pause / resume / retry), step inspection.\n",
    "nav": {
      "group": "Compute",
      "label": "Workflows",
      "order": 2,
      "icon": "lock"
    },
    "smithy": {
      "source": "unified-workflow-go/smithy/vex_uwf.smithy",
      "client": "@vextura/sdk-vex-uwf"
    },
    "resources": [
      {
        "name": "Workflow",
        "pattern": "ResourceList",
        "detail": {
          "pattern": "ResourceDetail",
          "tabs": [
            "overview",
            "definition",
            "executions"
          ]
        },
        "create": {
          "pattern": "CreateWizard",
          "steps": [
            "Identity",
            "Steps",
            "Review"
          ]
        }
      },
      {
        "name": "Execution",
        "pattern": "ResourceList",
        "detail": {
          "pattern": "ResourceDetail",
          "tabs": [
            "overview",
            "steps",
            "metrics",
            "data",
            "result"
          ]
        }
      }
    ],
    "tools": [],
    "exports": [],
    "consumes": [],
    "constraints": [
      {
        "description": "Lifecycle actions are guarded",
        "rules": [
          "Cancel / pause / resume require running or paused state",
          "Retry only on failed",
          "Retry-from-step requires step name"
        ]
      }
    ]
  },
  "vault": {
    "apiVersion": "vex.vextura.ai/console-section/v1",
    "service": "vault",
    "owner_team": "platform-security",
    "description": "Vex-vault — tenant-scoped secret + credential storage. The console\nsurface manages tenant secrets; platform-bootstrap secrets stay\nout of the UI per CLAUDE.md R7.\n",
    "nav": {
      "group": "Identity & Access",
      "label": "Vault",
      "order": 3,
      "icon": "lock"
    },
    "smithy": {
      "source": "vex-vault/smithy/vex_vault.smithy",
      "client": "@vextura/sdk-vex-vault"
    },
    "resources": [
      {
        "name": "Secret",
        "pattern": "ResourceList",
        "detail": {
          "pattern": "ResourceDetail",
          "tabs": [
            "overview",
            "metadata",
            "reveal"
          ]
        },
        "create": {
          "pattern": "CreateWizard",
          "steps": [
            "Identity",
            "Value",
            "Metadata",
            "Review"
          ]
        },
        "list": {
          "columns": [
            "id",
            "vrn",
            "tenant",
            "region",
            "updatedAt"
          ],
          "defaultSort": "id"
        }
      },
      {
        "name": "Credential",
        "pattern": "ResourceList",
        "detail": {
          "pattern": "ResourceDetail",
          "tabs": [
            "overview",
            "metadata"
          ]
        },
        "create": {
          "pattern": "CreateWizard",
          "steps": [
            "Identity",
            "UsernamePassword",
            "Endpoint",
            "Review"
          ]
        }
      }
    ],
    "tools": [],
    "exports": [],
    "consumes": [],
    "constraints": [
      {
        "description": "Plaintext values are only shown in Reveal flows",
        "rules": [
          "Secret value is hidden in list responses",
          "Detail screen requires explicit Reveal click — auto-remasks after 30s",
          "Credential password is never returned by the server"
        ]
      }
    ]
  }
};
